'use client'

import { Flex } from 'antd'

import { useEffect, useState } from 'react'

import { useGetCategoriesQuery } from 'modules/Category/model/api'
import { Category } from 'modules/Category/model/types'

import { useAppSearchParams } from 'shared/hooks/useAppSearchParams'

import { CategoryList } from '../../CategoryList/Desktop'
import { CategorySidebar } from '../../CategorySidebar/Desktop'

import styles from './CategoryContent.module.scss'

export function CategoryContent() {
  const { params } = useAppSearchParams()
  const { data: categories = [] } = useGetCategoriesQuery({})
  const [hoveredCategory, setHoveredCategory] = useState<Category | null>(null)

  useEffect(() => {
    if (categories.length === 0) return

    if (params.categoryId) {
      const category = categories.find(item => item.slug === params.categoryId)
      setHoveredCategory(category || null)
    } else {
      setHoveredCategory(categories[0])
    }
  }, [categories, params.categoryId])

  return (
    <div className={styles.wrapper}>
      <Flex gap={25}>
        <CategorySidebar
          categories={categories}
          hoveredCategory={hoveredCategory}
          setHoveredCategory={setHoveredCategory}
        />
      </Flex>

      {hoveredCategory && (
        <div className={styles.panel}>
          <CategoryList category={hoveredCategory} />
        </div>
      )}
    </div>
  )
}
